<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="row row-cols-1 row-cols-sm-2 py-4">
      <div class="col-12 d-flex mt-3 justify-content">
        <div class="col d-flex align-items-center">
          <h1 class="fs-4 fw-bold text-primary-color my-0">{{titulo}}</h1>
        </div>
      </div>
      <div class="col d-flex justify-content-sm-end align-items-center">
        <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill"
          (click)="incluirPrincipal()" [disabled]="!pesquisaInicialRealizada">
          Adicionar Novo Cargo na Hierarquia
        </button>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mb-4 mt-4"></nz-divider>

    <div class="d-flex">
      <div class="col-12 contrato-content pl-0 pr-0 border-gray box-shadow">
        <div #contratoContainer>

          <form [formGroup]="dominioFilterForm" id="dominiosFilterForm" (ngSubmit)="pesquisar()">
            <div class="row row-cols-1row-cols-sm-4 g-2">
              <ng-container *ngIf="nomeDominio == 'CARGO_TIPO_ENTIDADE'">
                <div class="col-12 col-sm-3 form-group">
                  <label for="tipoEntidade" class="form-label">Tipo de entidade</label>
                  <nz-select formControlName="tipoEntidade" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de entidade"
                    nzSize="large">
                    <nz-option [nzValue]="item.id" [nzLabel]="item?.nomeTipoEntidade"
                      *ngFor="let item of tipoEntidadeList" />
                  </nz-select>
                </div>
                <div class="col-12 col-sm-3 form-group">
                  <label for="subTipo" class="form-label">Sub Tipo:</label>
                  <nz-select formControlName="subTipo" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
                    nzPlaceHolder="Pesquise nome do sub tipo">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeSubTipoEntidade"
                      *ngFor="let item of subTipoList" />
                  </nz-select>
                </div>
                <!-- <ng-container *ngIf="tipoEntidadeOrgao">
                  <div class="col-12 col-sm-3 form-group">
                    <label for="especificacoes" class="form-label">Tipo de Órgão</label>
                    <nz-select formControlName="idEspecificacao" nzShowSearch nzAllowClear nzSize="large"
                      nzPlaceHolder="Pesquise o tipo de órgão">
                      <nz-option [nzValue]="item.id" [nzLabel]="item.nome"
                        *ngFor="let item of especializacaoSubtipoList" />
                    </nz-select>
                  </div>
                </ng-container> -->
                <div class="col-12 col-sm-2 form-group d-flex align-items-end ms-3">
                  <button nz-button nzType="primary" nzSize="large" class="rounded-pill" type="submit"
                    form="dominiosFilterForm">
                    Pesquisar
                  </button>

                  <button nz-button nzType="default" nzSize="large"
                    class="d-flex justify-content-center fw-semibold rounded-pill fs-6 ms-3" type="button"
                    (click)="voltar()">
                    Voltar
                  </button>
                </div>
              </ng-container>
            </div>
          </form>

          <nz-divider class="m-0 p-0 mt-4"></nz-divider>

          <app-lista-niveis-drag-and-drop [dataSet]="dataSet" [tipoEntidadePadrao]="tipoEntidadeControl"
            [subTipoPadrao]="subTipoControl"
            [incluirInativos]="incluirInativos" (atualizarDados)="atualizarEstrutura($event)"
            (salvar)="salvarItem($event)" (editar)="editarItem($event)" (remover)="removerItem($event)"
            (reativar)="reativarItem($event)" (removerSelecionados)="removerSelecionados($event)"
            (sortChange)="sort($event)">
          </app-lista-niveis-drag-and-drop> <!-- [especificacaoSubtipoPadrao]="especificacaoControl" -->

        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <router-outlet></router-outlet>
</div>
